const sum = (a: number, b: number) => a + b;
export const sumList = (list: number[]) => list.reduce(sum, 0);
